/* ============================================================
   Notre Chanson — shopify-config.js
   Boutique : Notre Chanson (n0cnqf-8s.myshopify.com)

   Produits déjà créés et publiés sur la Boutique en ligne :
     • Chanson personnalisée   39,00 €  (variante ...389393)
     • Le Coffret Souvenir     19,90 €  (variante ...913681)
     • Livraison Express 24 h   9,90 €  (variante ...241361)

   ⚠️ IL RESTE 1 SEULE CHOSE À FAIRE :
   coller ton TOKEN STOREFRONT public ci-dessous, puis passer
   enabled à true. (Guide dans le message de l'assistant.)
   Le token Storefront est PUBLIC et prévu pour le navigateur —
   ne mets jamais ici un token de l'Admin API.
   ============================================================ */
window.NM_SHOPIFY = {
  enabled: true,

  domain: 'n0cnqf-8s.myshopify.com',
  storefrontToken: '0030a57fb81e42e0cc76395a78df9566',   // jeton PUBLIC Storefront
  apiVersion: '2024-10',

  /* ⚠️ Une option dont la variante est vide reste MASQUÉE sur le panier.
     C'est volontaire : sans variante, le client verrait le prix dans le
     total sans que l'article parte chez Shopify → il paierait moins que
     le montant affiché. Collez l'ID pour activer l'option. */
  variants: {
    song:    'gid://shopify/ProductVariant/54310777389393',
    coffret: 'gid://shopify/ProductVariant/54310777913681',
    express: 'gid://shopify/ProductVariant/54310778241361',

    // Créés + publiés (4 canaux) le 18 juil via l'API Admin :
    couplet: 'gid://shopify/ProductVariant/54389774254417',   // « Ajouter le 3e couplet » — 12,90 €
    tip5:    'gid://shopify/ProductVariant/54389775663441',   // Pourboire 5 %  —  1,95 €
    tip10:   'gid://shopify/ProductVariant/54389775696209',   // Pourboire 10 % —  3,90 €
    tip15:   'gid://shopify/ProductVariant/54389775728977'    // Pourboire 15 % —  5,85 €
  }
};
